import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const packageData: Record<string, {
  name: string;
  packageTypes: string;
  price: string;
  position: number;
  publish: string;
  created: string;
}> = {
  '1': {
    name: '3-Class Renewal Package (select your own courses-9 hours)',
    packageTypes: 'generic package',
    price: '49.95',
    position: 1,
    publish: 'yes',
    created: '04/17/2011'
  },
  '2': {
    name: '#1 8-Class Salesperson Renewal Package (Preset-24 hours)',
    packageTypes: 'preset package',
    price: '89.95',
    position: 5,
    publish: 'yes',
    created: '04/17/2011'
  },
  '3': {
    name: '6-Class Salesperson Renewal Package (select your own courses-18 hours)',
    packageTypes: 'generic package',
    price: '69.95',
    position: 3,
    publish: 'yes',
    created: '04/17/2011'
  }
};
export function ViewPackage() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const pkg = packageData[id ?? '1'] ?? packageData['1'];
  return <div className="space-y-4" data-id="element-2524">
      <div className="flex items-center justify-between" data-id="element-2525">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2526">View Package</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/packages')} data-id="element-2527">
          ← Back to Packages
        </Button>
      </div>

      <Card data-id="element-2528">
        <CardContent className="pt-6" data-id="element-2529">
          <div className="space-y-6" data-id="element-2530">
            {/* Details table */}
            <div data-id="element-2531">
              <h2 className="text-base font-semibold text-slate-800 mb-3" data-id="element-2532">
                Package
              </h2>
              <table className="text-sm w-full max-w-lg" data-id="element-2533">
                <tbody data-id="element-2534">
                  <tr className="border-b border-slate-100" data-id="element-2535">
                    <td className="py-2 pr-6 font-medium text-slate-700 w-32 align-top" data-id="element-2536">
                      Name
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2537">{pkg.name}</td>
                  </tr>
                  <tr className="border-b border-slate-100" data-id="element-2538">
                    <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2539">
                      Package Types
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2540">{pkg.packageTypes}</td>
                  </tr>
                  <tr className="border-b border-slate-100" data-id="element-2541">
                    <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2542">
                      Price
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2543">{pkg.price}</td>
                  </tr>
                  <tr className="border-b border-slate-100" data-id="element-2544">
                    <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2545">
                      Position
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2546">{pkg.position}</td>
                  </tr>
                  <tr className="border-b border-slate-100" data-id="element-2547">
                    <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2548">
                      Publish
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2549">{pkg.publish}</td>
                  </tr>
                  <tr data-id="element-2550">
                    <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2551">
                      Created
                    </td>
                    <td className="py-2 text-slate-900" data-id="element-2552">{pkg.created}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Actions */}
            <div data-id="element-2553">
              <h2 className="text-base font-semibold text-slate-800 mb-2" data-id="element-2554">
                Actions
              </h2>
              <ul className="space-y-1 text-sm" data-id="element-2555">
                <li data-id="element-2556">
                  <button className="text-blue-600 hover:underline" onClick={() => navigate(`/packages/edit/${id}`)} data-id="element-2557">
                    Edit Package
                  </button>
                </li>
                <li data-id="element-2558">
                  <button className="text-blue-600 hover:underline" data-id="element-2559">
                    Delete Package
                  </button>
                </li>
                <li data-id="element-2560">
                  <button className="text-blue-600 hover:underline" onClick={() => navigate('/packages')} data-id="element-2561">
                    List Packages
                  </button>
                </li>
                <li data-id="element-2562">
                  <button className="text-blue-600 hover:underline" onClick={() => navigate('/packages/add')} data-id="element-2563">
                    New Package
                  </button>
                </li>
                <li data-id="element-2564">
                  <button className="text-blue-600 hover:underline" data-id="element-2565">
                    List Package Courses
                  </button>
                </li>
                <li data-id="element-2566">
                  <button className="text-blue-600 hover:underline" data-id="element-2567">
                    New Package Course
                  </button>
                </li>
              </ul>
            </div>

            {/* Related Package Courses */}
            <div data-id="element-2568">
              <h2 className="text-base font-semibold text-slate-800" data-id="element-2569">
                Related Package Courses
              </h2>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
}